import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";

@Injectable()
export class BlobErrorHttpInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (
          error instanceof HttpErrorResponse &&
          error.error instanceof Blob &&
          error.error.type === "application/json"
        ) {
          return new Promise<never>((_resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
              try {
                const errmsg = JSON.parse(reader.result as string);
                reject(
                  new HttpErrorResponse({
                    error: errmsg,
                    headers: error.headers,
                    status: error.status,
                    statusText: error.statusText,
                    url: error.url ?? undefined,
                  })
                );
              } catch {
                reject(error);
              }
            };
            reader.onerror = (_e) => {
              reject(error);
            };
            reader.readAsText(error.error);
          });
        }

        // Client Side Error
        if (error.error instanceof ErrorEvent) {
        } else {
          // Server Side Error
          return throwError(error);
        }
        return throwError(error);
      })
    );
  }
}
